import { BuiltinInterface } from '../../BuiltinInterface';
import { BuiltinValueObject } from '../../BuiltinValueObject';
import { DeploySenderAddress } from './senderAddress';
class DeployValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'DeployConstructor';
    }
}
class DeployConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addContractValue('Deploy', new DeployValue());
    builtins.addContractInterface('DeployConstructor', new DeployConstructorInterface());
    builtins.addContractMember('DeployConstructor', 'senderAddress', new DeploySenderAddress());
};

//# sourceMappingURL=index.js.map
